import type { ProductionDocument, NoteValue } from './model';
import type { NotesTransportStatus } from './transport';

export interface ProductionNotesController {
  document: ProductionDocument | null;
  projectId: string;
  storageError: string | null;
  error: string | null;
  status: NotesTransportStatus;
  shareUrl: string;
  setProjectFields(fields: Record<string, NoteValue>): void;
  setRecordFields(id: string, fields: Record<string, NoteValue>): void;
  addTake(scriptId?: string): string;
  deleteTake(id: string): void;
  exportProject(format: 'json' | 'csv'): void;
  importProject(file: File): Promise<void>;
  prepareShare(): Promise<string>;
}

// Shared documents deliberately allow scalar fields. Treat peer input defensively.
export function noteText(value: unknown, fallback = ''): string {
  return typeof value === 'string' ? value : fallback;
}
export function noteNumber(value: unknown, fallback = 0): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : fallback;
}
export function noteDate(value: unknown): string {
  const n = noteNumber(value, NaN);
  return Number.isFinite(n) && Math.abs(n) <= 8.64e15 ? new Date(n).toLocaleString() : '';
}
